const $19f3c469475076c6$var$API_KEY = "1WR15IYZ4yC7CGTEkriR81gIZWfhkXam";
const $19f3c469475076c6$var$BASE_URL = "https://api.giphy.com/v1/gifs/search";
async function $19f3c469475076c6$export$14461a2a12090e07(query) {
    const url = `${$19f3c469475076c6$var$BASE_URL}?api_key=${$19f3c469475076c6$var$API_KEY}&q=${query}&limit=10`; // Make API request
    try {
        const response = await fetch(url);
        const data = await response.json();
        return data.data; // Return GIF data
    } catch (error) {
        console.error("Error fetching GIFs:", error);
        return []; // Return empty array in case of error
    }
}


// Function to get the user's message
function $d88b1b225c388b44$export$21f2a2ec4d8120e4() {
    return document.getElementById("message-input").value.trim();
}
function $d88b1b225c388b44$export$7830029ca4a53320() {
    return document.getElementById("gif-query").value.trim();
}
function $d88b1b225c388b44$export$a8514b7c75124d16(gifs) {
    const gifResultsContainer = document.getElementById("gif-results");
    gifResultsContainer.innerHTML = ""; // Clear previous results
    if (gifs.length === 0) {
        gifResultsContainer.innerHTML = "<p>No GIFs found. Please try another search.</p>";
        return;
    }
    gifs.forEach((gif)=>{
        const img = document.createElement("img");
        img.src = gif.images.fixed_height_small.url;
        img.alt = gif.title;
        img.classList.add("gif");
        img.addEventListener("click", ()=>$d88b1b225c388b44$export$2eae0788d36ce59(gif.images.fixed_height.url));
        gifResultsContainer.appendChild(img);
    });
}
function $d88b1b225c388b44$export$2eae0788d36ce59(gifUrl) {
    const selectedGif = document.getElementById("selected-gif");
    selectedGif.innerHTML = `<img src="${gifUrl}" alt="Selected GIF" />`;
}
function $d88b1b225c388b44$export$c2be75a38cda5942() {
    document.getElementById("message-input").value = "";
    document.getElementById("gif-query").value = "";
    document.getElementById("gif-results").innerHTML = "";
    document.getElementById("selected-gif").innerHTML = "";
}


let $efd3ba4ec2608b1d$var$selectedGifUrl = null; // Declare selectedGifUrl here to store the selected GIF URL
// Fetch GIFs when the "Find GIFs" button is clicked
document.getElementById("fetch-gifs").addEventListener("click", async ()=>{
    const query = (0, $d88b1b225c388b44$export$7830029ca4a53320)() || "I miss you"; // Use user input or default to 'I miss you'
    const gifs = await (0, $19f3c469475076c6$export$14461a2a12090e07)(query);
    (0, $d88b1b225c388b44$export$a8514b7c75124d16)(gifs);
});
// Send the message when the "Send Message" button is clicked
document.getElementById("send-message").addEventListener("click", ()=>{
    const message = (0, $d88b1b225c388b44$export$21f2a2ec4d8120e4)();
    if (message && $efd3ba4ec2608b1d$var$selectedGifUrl) {
        console.log("Sending message:", message);
        console.log("With GIF:", $efd3ba4ec2608b1d$var$selectedGifUrl);
        // Here you would send the message and GIF
        alert(`Message sent: ${message}\nWith GIF: ${$efd3ba4ec2608b1d$var$selectedGifUrl}`);
        (0, $d88b1b225c388b44$export$c2be75a38cda5942)(); // Clear the input and selected GIF after sending
    } else alert("Please write a message and select a GIF.");
});
// Listen for the DOM content being loaded
document.addEventListener("DOMContentLoaded", function() {
    const fetchGifsButton = document.getElementById("fetch-gifs");
    const sendMessageButton = document.getElementById("send-message");
    // Fetch GIFs when the "Find GIFs" button is clicked
    fetchGifsButton.addEventListener("click", async function() {
        const query = (0, $d88b1b225c388b44$export$7830029ca4a53320)();
        if (!query) {
            alert("Please enter a search term.");
            return;
        }
        const gifs = await (0, $19f3c469475076c6$export$14461a2a12090e07)(query);
        (0, $d88b1b225c388b44$export$a8514b7c75124d16)(gifs);
    });
    // Listen for the click event on each displayed GIF
    document.getElementById("gif-results").addEventListener("click", function(e) {
        if (e.target.tagName === "IMG") {
            // Check if clicked element is an image (GIF)
            $efd3ba4ec2608b1d$var$selectedGifUrl = e.target.src; // Update selectedGifUrl with the clicked GIF URL
            const selectedGif = document.getElementById("selected-gif");
            selectedGif.innerHTML = `<img src="${$efd3ba4ec2608b1d$var$selectedGifUrl}" alt="Selected GIF">`;
        }
    });
    // Handle sending the message when the "Send Message" button is clicked
    sendMessageButton.addEventListener("click", function() {
        const message = (0, $d88b1b225c388b44$export$21f2a2ec4d8120e4)();
        if (!message) {
            alert("Please write a message before sending.");
            return;
        }
        if (!$efd3ba4ec2608b1d$var$selectedGifUrl) {
            alert("Please select a GIF.");
            return;
        }
        // Handle message submission (e.g., send to a server or log to console)
        console.log("Message:", message);
        console.log("Selected GIF:", $efd3ba4ec2608b1d$var$selectedGifUrl);
        alert("Message sent!");
        // Clear inputs after sending
        (0, $d88b1b225c388b44$export$c2be75a38cda5942)();
    });
});


//# sourceMappingURL=index.1c6be2a0.js.map
